import { ReactNode } from "@tanstack/react-router"

export function CustomHeader({ children }: { children: ReactNode }) {
	return <p className="text-dipai-text-primary pb-2 font-semibold">{children}</p>
}

export function CustomBodyText({ children }: { children: ReactNode }) {
	return (
		<p
			className={`text-dipai-text-primary bg-gray-eee rounded-sm border-1 px-2 py-1 text-justify`}
		>
			{" "}
			{children}
		</p>
	)
}

export function CustomBodyMultiText({ children }: { children: ReactNode[] }) {
	return (
		<div className={`bg-gray-eee flex flex-col gap-1 rounded-sm`}>
			{children.map((child, index) => child)}
		</div>
	)
}
